import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';
import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { CustomerService } from '../_services/customer.service'
import { DebtorService } from '../_services/debtor.service'
import { Invoice, PaymentProcess, Debtor, InvoiceList, Account, Notification, Recipient } from '../_models';
import { NotificationService } from '../_services/notification.service'
import { DatePipe, DecimalPipe } from '@angular/common';
import { PaymentProcessService } from '../_services/paymentprocess.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';

@Component({
    selector: 'salesinvoicedetail',
    templateUrl: './salesinvoicedetail.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']

})
export class SalesInvoiceDetailComponent implements OnInit {

    public customer_public_id: string;
    public customer_account_public_id: string;
    public user_public_id: string;

    htmlEditorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '25rem',
        minHeight: '5rem',
        placeholder: 'Texto aqui...',
        translate: 'no',
        uploadUrl: 'v1/images', // if needed
        customClasses: [ // optional
            {
                name: "quote",
                class: "quote",
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: "titleText",
                class: "titleText",
                tag: "h1",
            },
        ]
    };



    excelExportData: any;
    invoicePublic_key;
    scheduleDate: any;

    titleName: string;
    name: string;
    clientname: string;
    client_public_id: string;
    status: string;
    client: string;
    late_fee: string;
    sub_total: string;
    total: string;
    created: string;
    due_datetime: string;
    expiration_datetime: string;
    totalcurrency: string;
    invoicepublic_id: string;
    invoicetotalvalue: string;
    references: string;
    debtorpublic_id: string

    late_fee_symbol: string;
    sub_total_symbol: string;
    total_symbol: string;

    ////////

    debtorName: string;
    debtorPublicId: string;
    debtoremail: string;
    debtorPhone: string;
    debtordocumenttype: string;
    debtordocumentid: string;
    customerPublicId: string;



    public paymentprocessForm: FormGroup;
    public notificationForm: FormGroup;
    public notificationEditForm: FormGroup;

    public cusPsp_accountsList: Account[] = [];

    public cusDebtorAccountsList: Account[] = [];

    public invoicelist_temp: InvoiceList[] = [];
    public invoice_temp: Invoice;
    public InvoiceNotifyTemplateList: any;
    public custNotifyTemplateList: any;
    public indNotificationTemplateDetail: any;

    mdlNotificationInvoiceBody: any;

    tmpInvoiceDetails: any;
    tmpDebtorDetails: any;

    //historical table related variables and properties
    invHistoricalListDataSource = new MatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginatorHistorical: MatPaginator;
    @ViewChild('closeAddExpenseModal') closeAddExpenseModal: ElementRef;
    displayedColumns: string[] = ['created', 'description', 'name', 'username'];
    minDate = new Date();

    invNotificationListDataSource = new MatTableDataSource();
    displayedNotifyColumns: string[] = ['type', 'name', 'header', 'created', 'username', 'status', 'actions'];

    individualNotificationDetails: any;
    notTitle: any;
    notUserName: any;
    notReceiveEmail: any;
    notContent: any;
    notCreated: any;

    constructor
        (
            private router: Router, private formBuilder: FormBuilder, private excelService: ExcelService
            , private parameterData: ParameterData, private dataService: DataService
            , private invoicesService: InvoicesService
            , private readonly activatedRoute: ActivatedRoute
            , private paymentProcessService: PaymentProcessService
            , private _fbpayprocess: FormBuilder
            , private customerService: CustomerService
            , private debtorService: DebtorService
            , private notificatioService: NotificationService
            , private _fbnotification: FormBuilder
            , private datePipe: DatePipe
            , private decimalPipe: DecimalPipe
        ) {
        this.InitialSetup();
        this.InitialSetup_Notification();
        this.scheduleDate = new Date();
    }//end 


    InitialSetup() {

        this.paymentprocessForm = this._fbpayprocess.group({
            is_confirmed: new FormControl(""),
            reference: new FormControl(""),
            external_id: new FormControl(""),
            public_id: new FormControl(""),
            status: new FormControl(""),
            created: new FormControl(new Date()),

            debtor: this._fbpayprocess.group({
                public_id: new FormControl("Seleccione")
            }),

            user: this._fbpayprocess.group({
                public_id: ""
            }),

            psp_operation: this._fbpayprocess.group({
                external_id: new FormControl(""),
                channel: new FormControl("WEB"),
                method: new FormControl("CASH"),
                processing_date: new FormControl(new Date()),
                description: new FormControl(""),
                name: new FormControl(""),
                public_id: new FormControl(""),
                customer_account: this._fbpayprocess.group({
                    public_id: new FormControl("Seleccione")
                }),
                psp_account: this._fbpayprocess.group({
                    public_id: new FormControl("")
                }),
                total: this._fbpayprocess.group({
                    currency: new FormControl(""),
                    value: new FormControl("")
                })
            }),
            invoice_list: this._fbpayprocess.array([
                ({
                    id: [""],
                    public_id: [""],
                    late_fee: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    sub_total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    })
                })
            ])
        });



    }//end initial setup

    InitialSetup_Notification() {
        this.notificationForm = this._fbnotification.group({
            templatenames: new FormControl(""),
            NotificationFor: new FormControl(""),
            NotificationAffair: new FormControl(""),


            customer: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            header: new FormControl(""),
            name: new FormControl(""),
            scheduled: new FormControl(""),
            recipients: this._fbnotification.group({
                name: new FormControl(""),
                email: new FormControl("")
            }),

            user: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            object_related_public_id: new FormControl(""),
            content: new FormControl("")


        });

        var currentDueDate = new Date();
        this.notificationEditForm = this._fbnotification.group({
            templatenames: new FormControl(""),
            NotificationFor: new FormControl(""),
            NotificationAffair: new FormControl(""),


            customer: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            header: new FormControl(""),
            name: new FormControl(""),
            scheduled: new FormControl(new Date(currentDueDate)),
            recipients: this._fbnotification.group({
                name: new FormControl(""),
                email: new FormControl("")
            }),

            user: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            object_related_public_id: new FormControl(""),
            content: new FormControl("")


        });
    }//end



    ngOnInit() {


        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }




        this.paymentprocessForm.get('psp_operation.method').setValue('EFECTIVO');



        this.getpsp_account_publicId();


        this.getCustomerNotificationTemplateList("");



        //used to retrieve the customer public id
        let params: any = this.activatedRoute.snapshot.params;
        this.invoicePublic_key = params.id;

        this.GetIndividualInvoiceDetails();

        this.getInvoiceNotificationList();


    }//end



    /**
    * this function is used to get the customer account public id details.
    */
    getpsp_account_publicId() {

        this.customerService.getCustomerAccountList(this.customer_public_id)
            .subscribe(data => {
                this.cusPsp_accountsList = data;
            });

    }//end



    /**
     * this function is used to get Customer Notification Template List.
     */
    getInvoiceNotificationList() {
        this.invoicesService.getInvoiceNotificationList(this.invoicePublic_key)
            .subscribe(data => {
                let resources = data["data"];
                this.invNotificationListDataSource.data = resources;

            });

    }//end

    viewInvoiceNotDetails(element) {
        this.notificatioService.getNotification(element.public_id)
            .subscribe(data => {
                let resources = data;
                this.individualNotificationDetails = resources;
                this.notTitle = this.individualNotificationDetails.header;
                this.notUserName = this.individualNotificationDetails.user.name;
                this.notReceiveEmail = this.individualNotificationDetails.recipients[0].email;
                this.notContent = this.individualNotificationDetails.content;
                this.notCreated = this.individualNotificationDetails.created;

            });

    }


    /**
     * this function is used to get Customer Notification Template List.
     */
    getCustomerNotificationTemplateList(public_id: string) {
        this.customerService.getCustomerNotificationTemplateList(this.customer_public_id)
            .subscribe(data => {
                if (data && Array.isArray(data)) {
                    this.custNotifyTemplateList = data;
                    if (this.custNotifyTemplateList && this.custNotifyTemplateList.length > 0) {
                        this.notificationForm.controls.templatenames.setValue(this.custNotifyTemplateList[0].public_id);
                        this.getNotificationTempDetails(this.custNotifyTemplateList[0].public_id);
                    }
                } else {
                    this.custNotifyTemplateList = [];
                }
            }, error => {
                this.custNotifyTemplateList = [];
            });

    }//end

    getNotificationById(id: string) {

    }//end


    getNotificationTempDetails(publicId) {

        setTimeout(() => {

            this.customerService.getIndNotificationTemplateDetail(publicId)
                .subscribe(data => {
                    this.indNotificationTemplateDetail = data;

                    this.notificationForm.controls.header.setValue(this.replaceTemplateHeader(this.indNotificationTemplateDetail.header));

                    this.notificationForm.controls.name.setValue(this.debtoremail);

                    this.notificationForm.controls.content.setValue(this.replaceTemplateConstant(this.indNotificationTemplateDetail.content));
                });
        }, 500)
    }//end




    public options: Object = {
        charCounterCount: true,
        toolbarButtons: ['bold', 'italic', 'underline', 'paragraphFormat'],
        toolbarButtonsXS: ['bold', 'italic', 'underline', 'paragraphFormat'],
        toolbarButtonsSM: ['bold', 'italic', 'underline', 'paragraphFormat'],
        toolbarButtonsMD: ['bold', 'italic', 'underline', 'paragraphFormat'],
    };

    replaceTemplateHeader(value: string) {
        value = value.replace(/{{orden.referencia}}/gi, this.tmpInvoiceDetails.invoice_id);
        return value;
    }
    replaceTemplateConstant(value: string) {

        value = value.replace(/{{cliente.nombre}}/gi, this.debtorName);
        value = value.replace(/{{cliente.email}}/gi, this.debtoremail);
        value = value.replace(/{{cliente.telefono}}/gi, this.debtorPhone);
        value = value.replace(/{{cliente.tipo_documento}}/gi, this.debtordocumenttype);
        value = value.replace(/{{cliente.numero_documento}}/gi, this.debtordocumentid);

        value = value.replace(/{{orden.fecha}}/gi, this.datePipe.transform(this.tmpInvoiceDetails.created, 'dd/MM/yyyy'));

        value = value.replace(/{{orden.referencia}}/gi, this.tmpInvoiceDetails.invoice_id);
        value = value.replace(/{{orden.moneda}}/gi, this.tmpInvoiceDetails.total.symbol);
        value = value.replace(/{{orden.monto}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.total.value, '1.2-2', 'en-US'));


        value = value.replace(/{{orden.fechavencimiento}}/gi, (this.tmpInvoiceDetails.due_datetime == 'none' || this.tmpInvoiceDetails.due_datetime == 'None' || this.tmpInvoiceDetails.due_datetime == undefined) ? '' : this.datePipe.transform(this.tmpInvoiceDetails.due_datetime, 'dd/MM/yyyy'));
        value = value.replace(/{{orden.fechaexpiracion}}/gi, (this.tmpInvoiceDetails.expiration_datetime == 'none' || this.tmpInvoiceDetails.expiration_datetime == 'None' || this.tmpInvoiceDetails.expiration_datetime == undefined) ? '' : this.datePipe.transform(this.tmpInvoiceDetails.expiration_datetime, 'dd/MM/yyyy'));

        value = value.replace(/{{orden.subtotal}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.sub_total.value, '1.2-2', 'en-US'));
        value = value.replace(/{{orden.mora}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.late_fee.value, '1.2-2', 'en-US'));
        value = value.replace(/{{Orden.Descripcion}}/gi, this.tmpInvoiceDetails.metadata.order_description);

        value = value.replace(/{{orden.descripcion}}/gi, this.tmpInvoiceDetails.metadata.order_description);

        value = value.replace(/{{usuario.nombre}}/gi, localStorage.getItem('username'));
        value = value.replace(/{{usuario.email}}/gi, localStorage.getItem('userEmail'));
        return value;
    }//end

    GetIndividualInvoiceDetails() {
        this.invoicesService.getInvoice(this.invoicePublic_key).subscribe((data: Invoice) => {

            this.tmpInvoiceDetails = data;
            this.titleName = data.name;
            this.name = data.name;
            this.status = data.status;
            this.client = data.debtor.name;
            this.references = data.invoice_id;
            this.client_public_id = data.debtor.public_id;
            this.GetIndividualDebtorDetails();
            this.clientname = data.debtor.name;

            this.late_fee = data.late_fee.value.toString();
            this.sub_total = data.sub_total.value.toString();
            this.total = data.total.value.toString();
            this.late_fee_symbol = data.late_fee.symbol;
            this.sub_total_symbol = data.sub_total.symbol;
            this.total_symbol = data.total.symbol;
            this.created = data.created;
            this.due_datetime = data.due_datetime;
            this.expiration_datetime = data.expiration_datetime;

            this.totalcurrency = data.total.currency;
            this.invoicepublic_id = data.public_id;
            this.invoicetotalvalue = data.total.value.toString();
            this.debtorpublic_id = data.debtor.public_id;

            this.invHistoricalListDataSource.data = data.activity_list;


        },
            error => {
                console.log('Failed while trying to get Indvidual Invoice Detail. ' + error);
            });
    }//end

    GetIndividualDebtorDetails() {
        this.debtorService.getDebtor(this.client_public_id).subscribe((data: Debtor) => {
            this.debtorName = data.name;
            this.debtorPublicId = data.public_id;
            this.debtoremail = data.email;
            this.debtorPhone = data.phone;
            this.debtordocumenttype = data.document_type;
            this.debtordocumentid = data.document_id;
            this.customerPublicId = data.customer.public_id;

        },
            error => {
                console.log('Failed while trying to get Indvidual Debtor Detail. ' + error);
            });
    }//end


    onsubmitPaymentProcess({ value }: { value: PaymentProcess }) {
        let invarr: Invoice[] = [{ "public_id": this.invoicepublic_id, "total": { "currency": this.totalcurrency, "value": Number(this.invoicetotalvalue), "symbol": "" } }];
        value.invoice_list = invarr

        value.psp_operation.method = "CASH";
        value.psp_operation.total.currency = this.totalcurrency;
        value.psp_operation.total.value = Number(this.total);
        value.psp_operation.customer_account.public_id = this.customer_account_public_id;

        value.debtor.public_id = this.client_public_id;
        value.debtor.name = this.clientname;

        if (value.is_confirmed == true) {
            value.is_confirmed = true;
        }
        else {
            value.is_confirmed = false;
        }
        this.paymentProcessService.createPayment(value)
            .subscribe((result) => {

            }, error => {
                console.log('Failed while trying to update the payments Details.' + error);
            });




    }//end method

    onsubmitNotificationForm({ value }: { value: Notification }) {

        value.customer.public_id = this.customerPublicId;

        let recipientarr: Recipient[] = [{ "name": '', "email": value.name }];

        value.user.public_id = localStorage.getItem("userId");

        value.object_related_public_id = this.invoicepublic_id;
        value.sender = localStorage.getItem("userEmail");
        value.recipients = recipientarr;

        var result = confirm("Email a " + value.name + " fue enviado correctamente");
        if (result == true) {
            this.notificatioService.createNotification(value)
                .subscribe((notificationResult) => {
                    if (notificationResult.status == "201" || notificationResult.status == "400") {
                        this.closeAddExpenseModal.nativeElement.click();
                    }

                }, error => {
                    this.viewInvoice(this.invoicePublic_key);
                    console.log('Failed while trying to save the Notification Template Details.' + error);
                });
        }
        else {
            this.closeAddExpenseModal.nativeElement.click();
        }


    }//end method



    onConfirmInvoice() {

        this.invoicesService.deleteInvoice(this.invoicePublic_key)
            .subscribe((result) => {
                const application = localStorage.getItem('application');
                if (AccountTypeOptions[application] != undefined) {
                  this.router.navigate([`/${AccountTypeOptions[application]}/invoices`]);
                }
            }, error => {
                console.log('Failed while trying to cancel the invoice Details.' + error);
            });
    } //end method


    invoicegridActionClick(viewtype, publicid) {

        switch (viewtype) {
            case 'notificationedit':
                this.getIndNotificationDetails(publicid);
                break;
            case 'notificationreview':
                this.viewInvoice(this.invoicePublic_key);
                break;

            case 'notificationdelete':
                this.onConfirmNotificationDelete(publicid);

                break;

            default:
                this.viewInvoice(publicid);

        }//end switch

    }



    onConfirmNotificationDelete(publicid) {
        let StatusValue = { "status": "INACTIVE" };
        this.notificatioService.updateNotification(publicid, StatusValue)
            .subscribe((result) => {
                this.viewInvoice(publicid);
            }, error => {
                console.log('Failed while trying to cancel the invoice Details.' + error);
            });
    } //end method

    getIndNotificationDetails(publicId) {
        setTimeout(() => {
            this.notificatioService.getNotification(publicId)
                .subscribe(data => {
                    this.indNotificationTemplateDetail = data;
                    this.notificationEditForm = this._fbnotification.group({
                        header: new FormControl(this.replaceTemplateHeader(this.indNotificationTemplateDetail.header)),
                        name: new FormControl(this.indNotificationTemplateDetail.recipients[0].email),
                        scheduled: new FormControl(new Date(this.indNotificationTemplateDetail.scheduled)),
                        recipients: this._fbnotification.group({
                            name: new FormControl(this.indNotificationTemplateDetail.recipients[0].name),
                            email: new FormControl(this.indNotificationTemplateDetail.recipients[0].email)
                        }),
                        content: new FormControl(this.replaceTemplateConstant(this.indNotificationTemplateDetail.content)),


                    });
                });
        }, 500)
    }//end

    getInvoiceNotificationTemplateList(public_id: string) {

        this.customerService.getCustomerNotificationTemplateList(this.customer_public_id)
            .subscribe(data => {
                if (data && Array.isArray(data)) {
                    this.InvoiceNotifyTemplateList = data;
                } else {
                    this.InvoiceNotifyTemplateList = [];
                }
            }, error => {
                this.InvoiceNotifyTemplateList = [];
            });
    }//end

    onupdateNotification({ value }: { value: Notification }) {

        value.scheduled = this.scheduleDate;

        this.notificatioService.updateNotification(this.indNotificationTemplateDetail.public_id, value)
            .subscribe((result) => {
                this.viewInvoice(this.invoicePublic_key);
            }, error => {
                console.log('Failed while trying to cancel the Notification Details.' + error);
            });
    }

    viewInvoice(id) {
        const application = localStorage.getItem('application');
        if (AccountTypeOptions[application] != undefined) {
          this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${id}/view`]);
        }
      }

}//end class


